import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'DEMO CAM - Gestión de expedientes DEMO';


  constructor(private updates: SwUpdate) {
    this.checkForUpdates();
  }

  checkForUpdates() {
    if (this.updates.isEnabled) {
      this.updates.available.subscribe(() => {
        if (confirm('Nueva versión disponible. ¿Actualizar ahora?')) {
          this.updates.activateUpdate().then(() => {
            window.location.reload();
          });
        }
      });
    }
  }

}
